import { UTM_KEYS, utmFromUrl } from '../../../shared/utils/utm/index.ts';

export const CAREER_OFFER_ATTRIBUTION_COOKIE = 'career_offer_attribution';
export const CAREER_OFFER_ATTRIBUTION_DAYS = 30;

const MAX_ATTRIBUTION_VALUE_LENGTH = 200;

export type CareerOfferUtm = Partial<Record<(typeof UTM_KEYS)[number], string>>;

export type CareerOfferTouch = CareerOfferUtm & {
	capturedAt: string;
};

export type CareerOfferAttribution = {
	firstTouch: CareerOfferTouch;
	lastTouch: CareerOfferTouch;
};

export const extractCareerOfferUtm = (
	searchParams: URLSearchParams,
): CareerOfferUtm | null => {
	const rawUtm = utmFromUrl(searchParams);
	if (!rawUtm) return null;

	const utm: CareerOfferUtm = {};
	for (const key of UTM_KEYS) {
		const value = rawUtm[key];
		if (value) {
			utm[key] = value.slice(0, MAX_ATTRIBUTION_VALUE_LENGTH);
		}
	}

	return Object.keys(utm).length > 0 ? utm : null;
};

export const updateCareerOfferAttribution = (
	current: CareerOfferAttribution | null,
	incoming: CareerOfferUtm | null,
	capturedAt: string,
): CareerOfferAttribution | null => {
	if (!incoming) return current;

	const touch = { ...incoming, capturedAt };
	return {
		firstTouch: current?.firstTouch ?? touch,
		lastTouch: touch,
	};
};
